import React, { useCallback } from 'react';
import classNames from './style.module.scss';

import { concatClassNames } from '../../../utils/utilities';

interface TimelineProps {
    currentIndex: number;
    labels: string[];
}

const Timeline: React.FC<TimelineProps> = ({ currentIndex, labels }) => {
    const getSeparatorClassName = useCallback((stepIndex: number) => {
        if (currentIndex > stepIndex) return classNames.timelineSeparatorFilled;
        if (currentIndex === stepIndex) return classNames.timelineSeparatorProgress;
        return '';
    }, [currentIndex]);

    const getStepClassName = useCallback((stepIndex: number) => {
        if (currentIndex > stepIndex) return classNames.timelineStepFilled;
        if (currentIndex === stepIndex) return classNames.timelineStepProgress;
        return '';
    }, [currentIndex]);
    
    const getLabelClassName = useCallback((stepIndex: number) => {
        if (currentIndex > stepIndex) return classNames.timelineStepLabelFilled;
        if (currentIndex === stepIndex) return classNames.timelineStepLabelProgress;
        return '';
    }, [currentIndex]);

    return ( 
        <div className={classNames.timeline}>
            <div className={classNames.timelineInner}>
                {labels.map((label, index) => (
                    <React.Fragment key={label}>
                        <div className={concatClassNames([classNames.timelineSeparator, getSeparatorClassName(index)])}></div>
                        <div className={concatClassNames([classNames.timelineStep, getStepClassName(index)])}>
                            <div className={concatClassNames([classNames.timelineStepLabel, getLabelClassName(index), index % 2 === 0 ? classNames.timelineStepLabelAlternate : '' ])}>{label}</div>
                        </div>
                        <div className={concatClassNames([classNames.timelineSeparator, getSeparatorClassName(index)])}></div>
                    </React.Fragment>
                    )
                )}
            </div>
        </div>
     );
}
 
export default Timeline;